"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _errorBoundary = _interopRequireDefault(require("../common/error-boundary"));

var _notificationItem = _interopRequireDefault(require("../notification-panel/notification-item"));

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
var NotificationItem = (0, _notificationItem["default"])();

var ErrorDisplay = function ErrorDisplay(_ref) {
  var error = _ref.error;
  var notification = (0, _react.useMemo)(function () {
    return {
      type: 'error',
      message: error,
      id: 'cloud-export-error'
    };
  }, [error]);
  return /*#__PURE__*/_react["default"].createElement(_errorBoundary["default"], null, /*#__PURE__*/_react["default"].createElement(NotificationItem, {
    notification: notification,
    isExpanded: true
  }));
};

var _default = ErrorDisplay;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RhbHMvZXJyb3ItZGlzcGxheS50c3giXSwibmFtZXMiOlsiTm90aWZpY2F0aW9uSXRlbSIsIkVycm9yRGlzcGxheSIsImVycm9yIiwibm90aWZpY2F0aW9uIiwidHlwZSIsIm1lc3NhZ2UiLCJpZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFHQTs7QUFDQTs7QUFDQTs7QUFMQTtBQUNBO0FBS0EsSUFBTUEsZ0JBQWdCLEdBQUcsbUNBQXpCOztBQU1BLElBQU1DLFlBQXlDLEdBQUcsU0FBNUNBLFlBQTRDLE9BQWE7QUFBQSxNQUFYQyxLQUFXLFFBQVhBLEtBQVc7QUFDN0QsTUFBTUMsWUFBWSxHQUFHLG9CQUNuQjtBQUFBLFdBQU87QUFDTEMsTUFBQUEsSUFBSSxFQUFFLE9BREQ7QUFFTEMsTUFBQUEsT0FBTyxFQUFFSCxLQUZKO0FBR0xJLE1BQUFBLEVBQUUsRUFBRTtBQUhDLEtBQVA7QUFBQSxHQURtQixFQU1uQixDQUFDSixLQUFELENBTm1CLENBQXJCO0FBU0Esc0JBQ0UsZ0NBQUMseUJBQUQscUJBQ0UsZ0NBQUMsZ0JBQUQ7QUFBa0IsSUFBQSxZQUFZLEVBQUVDLFlBQWhDO0FBQThDLElBQUEsVUFBVTtBQUF4RCxJQURGLENBREY7QUFLRCxDQWZEOztlQWlCZUYsWSIsInNvdXJjZXNDb250ZW50IjpbIi8vIFNQRFgtTGljZW5zZS1JZGVudGlmaWVyOiBNSVRcbi8vIENvcHlyaWdodCBjb250cmlidXRvcnMgdG8gdGhlIGtlcGxlci5nbCBwcm9qZWN0XG5cbmltcG9ydCBSZWFjdCwge3VzZU1lbW99IGZyb20gJ3JlYWN0JztcbmltcG9ydCBFcnJvckJvdW5kYXJ5IGZyb20gJy4uL2NvbW1vbi9lcnJvci1ib3VuZGFyeSc7XG5pbXBvcnQgTm90aWZpY2F0aW9uSXRlbUZhY3RvcnkgZnJvbSAnLi4vbm90aWZpY2F0aW9uLXBhbmVsL25vdGlmaWNhdGlvbi1pdGVtJztcbmNvbnN0IE5vdGlmaWNhdGlvbkl0ZW0gPSBOb3RpZmljYXRpb25JdGVtRmFjdG9yeSgpO1xuXG5pbnRlcmZhY2UgRXJyb3JEaXNwbGF5UHJvcHMge1xuICBlcnJvcjogc3RyaW5nO1xufVxuXG5jb25zdCBFcnJvckRpc3BsYXk6IFJlYWN0LkZDPEVycm9yRGlzcGxheVByb3BzPiA9ICh7ZXJyb3J9KSA9PiB7XG4gIGNvbnN0IG5vdGlmaWNhdGlvbiA9IHVzZU1lbW8oXG4gICAgKCkgPT4gKHtcbiAgICAgIHR5cGU6ICdlcnJvcicsXG4gICAgICBtZXNzYWdlOiBlcnJvcixcbiAgICAgIGlkOiAnY2xvdWQtZXhwb3J0LWVycm9yJ1xuICAgIH0pLFxuICAgIFtlcnJvcl1cbiAgKTtcblxuICByZXR1cm4gKFxuICAgIDxFcnJvckJvdW5kYXJ5PlxuICAgICAgPE5vdGlmaWNhdGlvbkl0ZW0gbm90aWZpY2F0aW9uPXtub3RpZmljYXRpb259IGlzRXhwYW5kZWQgLz5cbiAgICA8L0Vycm9yQm91bmRhcnk+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBFcnJvckRpc3BsYXk7XG4iXX0=